// import

import type {ImageLoader, ImageLoaderProps, ImageProps} from 'next/image';
import NextImage from 'next/image';

// type

type Props = ImageProps & {loader?: ImageLoader};

type TransformFunc = (props: ImageLoaderProps) => string[];

// vars

const idRx = /^.*\/(v\d{10}\/.*)$/;

// fns

const createLoader = (transFn: TransformFunc) =>
  (_props: ImageLoaderProps) => [
    'https://res.cloudinary.com',
    process.env.CLOUDINARY_CLOUD_NAME,
    transFn(_props).join(','),
    _props.src.replace(idRx, '$1'),
  ].join('/');

export const resizeLoader = createLoader(({src, width, quality}) => [
  src.endsWith('.svg') ? 'f_svg' : 'f_auto',
  'c_limit',
  `w_${width}`,
  `q_${quality || 'auto'}`,
]);

export const squareLoader = createLoader(({width, quality}) => [
  'f_auto',
  'c_fill',
  'g_center',
  'ar_1:1',
  `w_${width}`,
  `q_${quality || 'auto'}`,
]);

// component

export function Image(props: Props) {
  const {loader = resizeLoader, ...rest} = props;

  return (
    <NextImage loader={loader} {...rest} />
  );
}

